import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { adminLogin, formatApiError } from "@/lib/admin-api";

export const AdminLogin = ({ onDone }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      onDone(await adminLogin(email, password));
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const field = "mt-2 h-12 w-full rounded-2xl border border-[#C86D51]/20 bg-[#FDFBF7] px-4 text-[#2C221E] outline-none focus:border-[#9E4429]";
  return (
    <form onSubmit={submit} className="mx-auto w-full max-w-sm" data-testid="admin-login-form">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#2C221E]"><Lock className="h-5 w-5 text-[#FBF5EE]" /></span>
      <h1 className="mt-6 font-serif text-5xl font-light text-[#2C221E]">Waitlist dashboard</h1>
      <p className="mt-2 text-sm text-[#6B5A52]">Private. For the Lunelle team only.</p>
      <label className="mt-8 block text-xs font-semibold uppercase tracking-[0.18em] text-[#7A665C]">Email
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" className={field} data-testid="admin-login-email-input" />
      </label>
      <label className="mt-4 block text-xs font-semibold uppercase tracking-[0.18em] text-[#7A665C]">Password
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" className={field} data-testid="admin-login-password-input" />
      </label>
      {error && <p className="mt-4 text-sm text-[#A3271F]" data-testid="admin-login-error">{error}</p>}
      <button type="submit" disabled={busy} data-testid="admin-login-submit-button"
        className="mt-6 flex h-12 w-full items-center justify-center gap-2 rounded-full bg-[#9E4429] text-sm font-semibold text-[#FBF5EE] hover:bg-[#843722]">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
      </button>
    </form>
  );
};
